// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-2ea595b7]{width:25vw;align-content:center}.panel[data-v-2ea595b7]{padding:20px!important}.results-container[data-v-2ea595b7]{padding:2px}.results-content[data-v-2ea595b7]{display:flex;flex-direction:column;padding:10px;text-align:left}@media screen and (max-width:768px){.card[data-v-2ea595b7]{width:100%;margin:10px!important}}", ""]);
// Exports
module.exports = exports;
